// Public surface of the opportunities sub-namespace.

const expectationVariants = require('./expectation_variants');
const mentionDuplicates = require('./mention_duplicates');
const productScope = require('./product_scope');
const payoutPolicy = require('./payout_policy');
const strategyOpportunities = require('./strategy_opportunities');

const MAX_REVIEW_PERIOD_DAYS = 30;
const { OPPORTUNITY_REPORTING_REFRESH_RETRY_HOURS, OPPORTUNITY_PAYOUT_TRAILING_DAYS, STATS_FENCE_BUFFER_DAYS, isOpportunityResultFinalized, getOpportunityReviewLockReason } = require('./review_window');

const getSpendLimitBelowCommittedSpendMessage = committedSpend =>
  `Spend limit cannot be below $${Number(committedSpend).toLocaleString('en-US')} (already committed to accepted creators)`;

module.exports = {
  MAX_REVIEW_PERIOD_DAYS,
  OPPORTUNITY_REPORTING_REFRESH_RETRY_HOURS,
  OPPORTUNITY_PAYOUT_TRAILING_DAYS,
  STATS_FENCE_BUFFER_DAYS,
  isOpportunityResultFinalized,
  getOpportunityReviewLockReason,
  getSpendLimitBelowCommittedSpendMessage,
  expectationVariants,
  getDuplicateMentionExclusionNote: mentionDuplicates.getDuplicateMentionExclusionNote,
  isDuplicateMentionExclusion: mentionDuplicates.isDuplicateMentionExclusion,
  getExpectationVariant: expectationVariants.getExpectationVariant,
  buildExpectationVariantCards: expectationVariants.buildExpectationVariantCards,
  buildRequiredSourceQualifier: expectationVariants.buildRequiredSourceQualifier,
  buildRequiredSourceSentence: expectationVariants.buildRequiredSourceSentence,
  resolveLinkDomains: expectationVariants.resolveLinkDomains,
  EXPECTATION_VARIANT_IDS: expectationVariants.EXPECTATION_VARIANT_IDS,
  EXPECTATION_CARD_KINDS: expectationVariants.EXPECTATION_CARD_KINDS,
  PLATFORM_EDUCATION: expectationVariants.PLATFORM_EDUCATION,
  MIN_LINK_CLICKS: expectationVariants.MIN_LINK_CLICKS,
  productScope,
  PIN_ELIGIBILITY_REASONS: productScope.PIN_ELIGIBILITY_REASONS,
  PRODUCT_SCOPE_MESSAGES: productScope.PRODUCT_SCOPE_MESSAGES,
  OPPORTUNITY_PAYOUT_POLICIES: payoutPolicy.OPPORTUNITY_PAYOUT_POLICIES,
  STRATEGY_PAYOUT_POLICIES: payoutPolicy.STRATEGY_PAYOUT_POLICIES,
  isStrategyPayoutPolicy: payoutPolicy.isStrategyPayoutPolicy,
  isActiveStrategySettings: payoutPolicy.isActiveStrategySettings,
  getStrategyPayoutPolicyForDelayDays: payoutPolicy.getStrategyPayoutPolicyForDelayDays,
  getEffectivePayoutPolicy: payoutPolicy.getEffectivePayoutPolicy,
  getExpectedPayoutDate: payoutPolicy.getExpectedPayoutDate,
  getPayoutReadyAt: payoutPolicy.getPayoutReadyAt,
  getProjectedPayoutReleasableAt: payoutPolicy.getProjectedPayoutReleasableAt,
  isOpportunityResultInReviewPeriod: payoutPolicy.isOpportunityResultInReviewPeriod,
  formatPayoutDate: payoutPolicy.formatPayoutDate,
  PAYOUT_TIMING_PREFIX: payoutPolicy.PAYOUT_TIMING_PREFIX,
  describePayoutTiming: payoutPolicy.describePayoutTiming,
  describePayoutPromise: payoutPolicy.describePayoutPromise,
  describeHeldBonus: payoutPolicy.describeHeldBonus,
  isStrategyOpportunity: strategyOpportunities.isStrategyOpportunity
};
